import { render, staticRenderFns } from "./PlayerSettings.vue?vue&type=template&id=9801a83a&scoped=true&"
import script from "./PlayerSettings.vue?vue&type=script&lang=js&"
export * from "./PlayerSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9801a83a",
  null
  
)

export default component.exports